// extracted by mini-css-extract-plugin
var _1 = "AiCopilotChatPanel-module__animateUploadProgressBarWidth--Vbo3i";
var _2 = "AiCopilotChatPanel-module__animatedBackground--cFcRS";
var _3 = "AiCopilotChatPanel-module__badge--kQmNi";
var _4 = "AiCopilotChatPanel-module__container--EPG6e";
var _5 = "AiCopilotChatPanel-module__footer--Kg_aj";
var _6 = "AiCopilotChatPanel-module__menuItem--W4RYg";
var _7 = "AiCopilotChatPanel-module__scrollToBottomButton--KoApr";
var _8 = "AiCopilotChatPanel-module__scrollToBottomButtonContainer--W1OmY";
var _9 = "AiCopilotChatPanel-module__submenuItem--t7DEG";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "container", _5 as "footer", _6 as "menuItem", _7 as "scrollToBottomButton", _8 as "scrollToBottomButtonContainer", _9 as "submenuItem" }
